export default {
  'pages.houseUser.title': '房主管理',
  'pages.houseUser.subTitle': '管理小区内的业主、租户和访客信息',
  'pages.houseUser.detail.title': '用户详情',
  'pages.houseUser.detail.breadcrumb': '用户详情',
  'pages.houseUser.detail.tab.properties': '用户属性',
  'pages.houseUser.detail.tab.houses': '房产信息',
  'pages.houseUser.detail.tab.rentInfo': '租房信息',
  'pages.houseUser.detail.tab.tenants': '租客管理',
  'pages.houseUser.detail.tab.parking': '停车位',
  'pages.houseUser.detail.tab.services': '开通服务',
  'pages.houseUser.detail.tab.files': '用户文档',
  'pages.houseUser.detail.tab.contacts': '紧急联系人',
  'pages.houseUser.detail.card.accountInfo': '账户信息',
  'pages.houseUser.detail.card.basicInfo': '基本信息',
  'pages.houseUser.detail.card.contactInfo': '联系方式',
  'pages.houseUser.detail.card.residenceInfo': '居住信息',
  'pages.houseUser.detail.card.remarks': '备注信息',
  'pages.houseUser.detail.card.parkingList': '停车位列表',
  'pages.houseUser.detail.label.username': '用户名',
  'pages.houseUser.detail.label.role': '角色',
  'pages.houseUser.detail.label.status': '状态',
  'pages.houseUser.detail.label.name': '姓名',
  'pages.houseUser.detail.label.gender': '性别',
  'pages.houseUser.detail.label.birthDate': '出生日期',
  'pages.houseUser.detail.label.idCard': '身份证号',
  'pages.houseUser.detail.label.phone': '手机号码',
  'pages.houseUser.detail.label.email': '电子邮箱',
  'pages.houseUser.detail.label.moveInDate': '入住日期',
  'pages.houseUser.detail.label.moveOutDate': '搬出日期',
  'pages.houseUser.detail.label.postalCode': '邮政编码',
  'pages.houseUser.detail.label.address': '详细地址',
  'pages.houseUser.detail.button.edit': '编辑',
  'pages.houseUser.detail.button.view': '查看',
  'pages.houseUser.detail.button.addHouse': '+ 添加房屋',
  'pages.houseUser.detail.button.addContact': '添加联系人',
  'pages.houseUser.detail.button.addTenant': '+ 添加租客',
  'pages.houseUser.detail.button.unbind': '解绑',
  'pages.houseUser.detail.button.bindParking': '绑定车位',
  'pages.houseUser.detail.button.delete': '删除',
  'pages.houseUser.detail.parking.bindModalTitle': '绑定车位',
  'pages.houseUser.detail.parking.searchPlaceholder': '请输入车位号搜索',
  'pages.houseUser.detail.parking.selectHint': '请选择要绑定的车位',
  'pages.houseUser.detail.parking.selectedSummary':
    '已选择：{parkingNumber}（{buildingName} / {floorName}）',
  'pages.houseUser.detail.parking.unbindConfirm':
    '确认解绑该车位与当前业主的关联？',
  'pages.houseUser.detail.parking.bindSuccess': '绑定成功',
  'pages.houseUser.detail.parking.bindFailed': '绑定失败',
  'pages.houseUser.detail.parking.unbindSuccess': '解绑成功',
  'pages.houseUser.detail.parking.unbindFailed': '解绑失败',
  'pages.houseUser.detail.parking.selectFirst': '请先搜索并选择车位',
  'pages.houseUser.detail.parking.status.unbound': '未绑定',
  'pages.houseUser.detail.parking.status.boundSelf': '已绑定',
  'pages.houseUser.detail.parking.status.boundOther': '他人已绑定',
  'pages.houseUser.detail.parking.popconfirmOk': '确认',
  'pages.houseUser.detail.parking.popconfirmCancel': '取消',
  'pages.houseUser.detail.table.house.buildingName': '楼栋名称',
  'pages.houseUser.detail.table.house.floor': '楼层',
  'pages.houseUser.detail.table.house.houseNumber': '房屋编号',
  'pages.houseUser.detail.table.house.houseType': '房屋类型',
  'pages.houseUser.detail.table.house.area': '房屋面积',
  'pages.houseUser.detail.table.house.status': '房屋状态',
  'pages.houseUser.detail.table.house.operations': '操作',
  'pages.houseUser.detail.table.contact.contactName': '联系人姓名',
  'pages.houseUser.detail.table.contact.contactPhone': '联系人电话',
  'pages.houseUser.detail.table.contact.relationship': '与业主关系',
  'pages.houseUser.detail.table.contact.remarks': '备注',
  'pages.houseUser.detail.table.contact.createdTime': '创建时间',
  'pages.houseUser.detail.table.contact.operations': '操作',
  'pages.houseUser.detail.status.enabled': '正常',
  'pages.houseUser.detail.status.disabled': '禁用',
  'pages.houseUser.detail.status.other': '其他',
  'pages.houseUser.detail.status.active': '启用',
  'pages.houseUser.detail.status.inactive': '停用',
  'pages.houseUser.detail.status.available': '可用',
  'pages.houseUser.detail.status.sold': '已售',
  'pages.houseUser.detail.status.rented': '已租',
  'pages.houseUser.detail.status.reserved': '预留',
  'pages.houseUser.detail.status.expired': '已过期',
  'pages.houseUser.detail.status.pending': '未开始',
  'pages.houseUser.detail.status.expiring': '即将到期',
  'pages.houseUser.detail.status.vacant': '空置',
  'pages.houseUser.detail.status.occupied': '已出租',
  'pages.houseUser.detail.status.selfOccupied': '自住',
  'pages.houseUser.detail.status.underRepair': '维修',
  'pages.houseUser.detail.role.owner': '业主',
  'pages.houseUser.detail.role.tenant': '租户',
  'pages.houseUser.detail.role.visitor': '访客',
  'pages.houseUser.detail.houseType.residential': '住宅',
  'pages.houseUser.detail.houseType.commercial': '商业',
  'pages.houseUser.detail.houseType.office': '办公',
  'pages.houseUser.detail.houseType.other': '其他',
  'pages.houseUser.detail.parkingType.ground': '地面车位',
  'pages.houseUser.detail.parkingType.underground': '地下车位',
  'pages.houseUser.detail.parkingType.mechanical': '机械车位',
  'pages.houseUser.detail.billingCycle.daily': '按日',
  'pages.houseUser.detail.billingCycle.monthly': '按月',
  'pages.houseUser.detail.billingCycle.quarterly': '按季度',
  'pages.houseUser.detail.billingCycle.yearly': '按年',
  'pages.houseUser.detail.billingUnit.month': '月',
  'pages.houseUser.detail.billingUnit.day': '日',
  'pages.houseUser.detail.billingUnit.year': '年',
  'pages.houseUser.detail.billingUnit.unit': '户',
  'pages.houseUser.detail.billingUnit.squareMeter': '平方米',
  'pages.houseUser.detail.message.updateSuccess': '更新成功',
  'pages.houseUser.detail.message.unbindSuccess': '解绑成功',
  'pages.houseUser.detail.message.unbindFailed': '解绑失败',
  'pages.houseUser.detail.message.deleteHouseSuccess': '删除房屋成功',
  'pages.houseUser.detail.message.deleteHouseFailed': '删除房屋失败',
  'pages.houseUser.detail.message.deleteContactSuccess': '删除紧急联系人成功',
  'pages.houseUser.detail.message.deleteContactFailed': '删除紧急联系人失败',
  'pages.houseUser.detail.message.loadHousesFailed': '加载房屋列表失败',
  'pages.houseUser.detail.message.loadParkingFailed': '加载停车位列表失败',
  'pages.houseUser.detail.message.loadContactsFailed': '加载紧急联系人列表失败',
  'pages.houseUser.detail.message.loadTenantsFailed': '加载租客列表失败',
  'pages.houseUser.detail.message.loadRentInfoFailed': '加载租房信息失败',
  'pages.houseUser.detail.message.loadServicesFailed': '加载已开通服务失败',
  'pages.houseUser.detail.confirm.unbindRent.title': '确认解绑',
  'pages.houseUser.detail.confirm.unbindRent.content':
    '确定要解除该租房关系吗？',
  'pages.houseUser.detail.confirm.unbindTenant.title': '确认解绑',
  'pages.houseUser.detail.confirm.unbindTenant.content':
    '确定要解除与该租客的绑定关系吗？',
  'pages.houseUser.detail.confirm.deleteContact.title': '确认删除',
  'pages.houseUser.detail.confirm.deleteContact.content':
    '确定要删除这个紧急联系人吗？',
  'pages.houseUser.detail.confirm.okText': '确定',
  'pages.houseUser.detail.confirm.cancelText': '取消',
  'pages.houseUser.detail.empty.noHouses': '暂无房产数据',
  'pages.houseUser.detail.empty.noRentInfo': '暂无租房信息',
  'pages.houseUser.detail.empty.noTenants': '暂无租客数据',
  'pages.houseUser.detail.empty.noParking': '暂无停车位数据',
  'pages.houseUser.detail.empty.noServices': '暂无已开通的服务',
  'pages.houseUser.detail.empty.noContacts': '暂无紧急联系人',
  'pages.houseUser.detail.loading': '加载中...',
  'pages.houseUser.detail.locationInfo': '位置信息',
  'pages.houseUser.detail.structureCode': '结构编码',
  'pages.houseUser.detail.parkingType': '车位类型',
  'pages.houseUser.detail.startTime': '开始时间',
  'pages.houseUser.detail.ownerInfo': '业主信息',
  'pages.houseUser.detail.tenantName': '租客姓名',
  'pages.houseUser.detail.houseInfo': '房屋信息',
  'pages.houseUser.detail.monthlyRent': '月租金',
  'pages.houseUser.detail.leaseStartDate': '租赁开始',
  'pages.houseUser.detail.leaseEndDate': '租赁结束',
  'pages.houseUser.detail.buildingName': '楼栋',
  'pages.houseUser.detail.floor': '楼层',
  'pages.houseUser.detail.houseNumber': '房屋号',
  'pages.houseUser.detail.area': '面积',
  'pages.houseUser.detail.amount': '金额',
  'pages.houseUser.detail.remarks': '备注',
  'pages.houseUser.detail.serviceCount': '服务数',
  'pages.houseUser.detail.bindVehicle': '已绑定车辆',
  'pages.houseUser.detail.noVehicle': '暂无绑定车辆',
  'pages.houseUser.detail.brandModel': '品牌/型号',
  'pages.houseUser.detail.vehicleColor': '车辆颜色',
  'pages.houseUser.detail.vehicleType': '车辆类型',
  'pages.houseUser.detail.registrationDate': '注册日期',
  'pages.houseUser.detail.bindVehicleButton': '+ 绑定车辆',
  'pages.houseUser.detail.editVehicleButton': '编辑',
  'pages.houseUser.detail.daysLeft': '即将到期({days}天)',
  'pages.houseUser.emergencyContact.title.view': '查看紧急联系人',
  'pages.houseUser.emergencyContact.title.edit': '编辑紧急联系人',
  'pages.houseUser.emergencyContact.title.add': '添加紧急联系人',
  'pages.houseUser.emergencyContact.button.close': '关闭',
  'pages.houseUser.emergencyContact.button.update': '更新',
  'pages.houseUser.emergencyContact.button.add': '添加',
  'pages.houseUser.emergencyContact.label.ownerName': '业主姓名',
  'pages.houseUser.emergencyContact.label.contactName': '联系人姓名',
  'pages.houseUser.emergencyContact.label.contactPhone': '联系人电话',
  'pages.houseUser.emergencyContact.label.relationship': '与业主关系',
  'pages.houseUser.emergencyContact.label.remarks': '备注',
  'pages.houseUser.emergencyContact.placeholder.contactName':
    '请输入联系人姓名',
  'pages.houseUser.emergencyContact.placeholder.contactPhone':
    '请输入联系人电话',
  'pages.houseUser.emergencyContact.placeholder.relationship':
    '如：父亲、母亲、配偶、子女等',
  'pages.houseUser.emergencyContact.placeholder.remarks': '请输入备注信息',
  'pages.houseUser.emergencyContact.validation.contactName.required':
    '请输入联系人姓名',
  'pages.houseUser.emergencyContact.validation.contactPhone.required':
    '请输入联系人电话',
  'pages.houseUser.emergencyContact.validation.contactPhone.invalid':
    '请输入正确的手机号码',
  'pages.houseUser.emergencyContact.validation.relationship.required':
    '请输入与业主关系',
  'pages.houseUser.emergencyContact.message.updateSuccess':
    '更新紧急联系人成功',
  'pages.houseUser.emergencyContact.message.addSuccess': '添加紧急联系人成功',
  'pages.houseUser.emergencyContact.message.updateFailed': '更新失败',
  'pages.houseUser.emergencyContact.message.addFailed': '添加失败',
  'pages.houseUser.emergencyContact.message.submitFailed': '提交失败',
  'pages.houseUser.houseManagement.title.edit': '编辑房屋信息',
  'pages.houseUser.houseManagement.title.add': '新增房屋',
  'pages.houseUser.houseManagement.label.building': '所属楼栋',
  'pages.houseUser.houseManagement.label.floor': '楼层',
  'pages.houseUser.houseManagement.label.unit': '单元号',
  'pages.houseUser.houseManagement.label.houseNumber': '房号',
  'pages.houseUser.houseManagement.label.area': '建筑面积(㎡)',
  'pages.houseUser.houseManagement.label.houseType': '房屋类型',
  'pages.houseUser.houseManagement.label.status': '房屋状态',
  'pages.houseUser.houseManagement.label.price': '房屋价值(元)',
  'pages.houseUser.houseManagement.label.remarks': '备注',
  'pages.houseUser.houseManagement.label.ownerInfo': '业主信息',
  'pages.houseUser.houseManagement.label.ownerName': '业主姓名',
  'pages.houseUser.houseManagement.label.ownerId': '业主ID',
  'pages.houseUser.houseManagement.placeholder.building': '请选择楼栋',
  'pages.houseUser.houseManagement.placeholder.floor': '请先选择楼栋',
  'pages.houseUser.houseManagement.placeholder.unit': '请输入单元号（如果有）',
  'pages.houseUser.houseManagement.placeholder.houseNumber': '请输入房号',
  'pages.houseUser.houseManagement.placeholder.area': '请输入建筑面积',
  'pages.houseUser.houseManagement.placeholder.houseType': '请选择房屋类型',
  'pages.houseUser.houseManagement.placeholder.status': '请选择房屋状态',
  'pages.houseUser.houseManagement.placeholder.price': '请输入房屋价值',
  'pages.houseUser.houseManagement.placeholder.remarks': '请输入备注信息',
  'pages.houseUser.houseManagement.validation.building.required': '请选择楼栋',
  'pages.houseUser.houseManagement.validation.floor.required': '请选择楼层',
  'pages.houseUser.houseManagement.validation.houseNumber.required':
    '请输入房号',
  'pages.houseUser.houseManagement.validation.houseType.required':
    '请选择房屋类型',
  'pages.houseUser.houseManagement.validation.status.required':
    '请选择房屋状态',
  'pages.houseUser.houseManagement.message.loadBuildingsFailed':
    '加载楼栋列表失败',
  'pages.houseUser.houseManagement.message.loadFloorsFailed':
    '加载楼层列表失败',
  'pages.houseUser.houseManagement.message.updateSuccess': '房屋更新成功',
  'pages.houseUser.houseManagement.message.createSuccess': '房屋创建成功',
  'pages.houseUser.houseManagement.message.updateFailed': '更新房屋失败',
  'pages.houseUser.houseManagement.message.createFailed': '创建房屋失败',
  'pages.houseUser.form.title.edit': '编辑房主',
  'pages.houseUser.form.title.create': '新建房主',
  'pages.houseUser.form.label.username': '用户名',
  'pages.houseUser.form.label.password': '密码',
  'pages.houseUser.form.label.confirmPassword': '确认密码',
  'pages.houseUser.form.label.name': '姓名',
  'pages.houseUser.form.label.gender': '性别',
  'pages.houseUser.form.label.birthDate': '出生日期',
  'pages.houseUser.form.label.idCard': '身份证号',
  'pages.houseUser.form.label.phone': '联系电话',
  'pages.houseUser.form.label.email': '邮箱',
  'pages.houseUser.form.label.address': '详细地址',
  'pages.houseUser.form.label.role': '角色',
  'pages.houseUser.form.label.status': '状态',
  'pages.houseUser.form.label.moveInDate': '入住日期',
  'pages.houseUser.form.label.moveOutDate': '搬出日期',
  'pages.houseUser.form.label.leaseStartDate': '租期开始日期',
  'pages.houseUser.form.label.leaseEndDate': '租期结束日期',
  'pages.houseUser.form.label.monthlyRent': '月租金(元)',
  'pages.houseUser.form.label.depositAmount': '押金金额(元)',
  'pages.houseUser.form.label.occupation': '职业',
  'pages.houseUser.form.label.workUnit': '工作单位',
  'pages.houseUser.form.label.emergencyContact': '紧急联系人',
  'pages.houseUser.form.label.emergencyPhone': '紧急联系电话',
  'pages.houseUser.form.label.remarks': '备注',
  'pages.houseUser.form.placeholder.username': '请输入用户名',
  'pages.houseUser.form.placeholder.password': '请输入密码',
  'pages.houseUser.form.placeholder.confirmPassword': '请再次输入密码',
  'pages.houseUser.form.placeholder.name': '请输入姓名',
  'pages.houseUser.form.placeholder.gender': '请选择性别',
  'pages.houseUser.form.placeholder.birthDate': '请选择出生日期',
  'pages.houseUser.form.placeholder.idCard': '请输入身份证号',
  'pages.houseUser.form.placeholder.phone': '请输入联系电话',
  'pages.houseUser.form.placeholder.email': '请输入邮箱',
  'pages.houseUser.form.placeholder.address': '请输入详细地址',
  'pages.houseUser.form.placeholder.role': '请选择角色',
  'pages.houseUser.form.placeholder.status': '请选择状态',
  'pages.houseUser.form.placeholder.moveInDate': '请选择入住日期',
  'pages.houseUser.form.placeholder.moveOutDate': '请选择搬出日期',
  'pages.houseUser.form.placeholder.leaseStartDate': '请选择租期开始日期',
  'pages.houseUser.form.placeholder.leaseEndDate': '请选择租期结束日期',
  'pages.houseUser.form.placeholder.monthlyRent': '请输入月租金',
  'pages.houseUser.form.placeholder.depositAmount': '请输入押金金额',
  'pages.houseUser.form.placeholder.occupation': '请输入职业',
  'pages.houseUser.form.placeholder.workUnit': '请输入工作单位',
  'pages.houseUser.form.placeholder.emergencyContact': '请输入紧急联系人',
  'pages.houseUser.form.placeholder.emergencyPhone': '请输入紧急联系电话',
  'pages.houseUser.form.placeholder.remarks': '请输入备注信息',
  'pages.houseUser.form.validation.username.required': '请输入用户名',
  'pages.houseUser.form.validation.username.minLength': '用户名长度不能少于4位',
  'pages.houseUser.form.validation.username.pattern':
    '用户名只能包含字母、数字和下划线',
  'pages.houseUser.form.validation.password.required': '请输入密码',
  'pages.houseUser.form.validation.password.minLength': '密码长度不能少于6位',
  'pages.houseUser.form.validation.confirmPassword.required': '请再次输入密码',
  'pages.houseUser.form.validation.confirmPassword.mismatch':
    '两次输入的密码不一致',
  'pages.houseUser.form.validation.name.required': '请输入姓名',
  'pages.houseUser.form.validation.name.minLength': '姓名长度不能少于2位',
  'pages.houseUser.form.validation.gender.required': '请选择性别',
  'pages.houseUser.form.validation.idCard.required': '请输入身份证号',
  'pages.houseUser.form.validation.idCard.pattern': '请输入正确的身份证号',
  'pages.houseUser.form.validation.phone.required': '请输入联系电话',
  'pages.houseUser.form.validation.phone.pattern': '请输入正确的手机号码',
  'pages.houseUser.form.validation.email.pattern': '请输入正确的邮箱格式',
  'pages.houseUser.form.validation.role.required': '请选择角色',
  'pages.houseUser.form.validation.status.required': '请选择状态',
  'pages.houseUser.form.button.update': '更新',
  'pages.houseUser.form.button.create': '创建',
  'pages.houseUser.form.button.cancel': '取消',
  'pages.houseUser.form.message.updateSuccess': '更新成功',
  'pages.houseUser.form.message.createSuccess': '创建成功',
  'pages.houseUser.form.message.updateFailed': '更新失败',
  'pages.houseUser.form.message.createFailed': '创建失败',
  'pages.houseUser.form.message.operationFailed': '操作失败',
  'pages.houseUser.formNew.title.edit': '编辑房主',
  'pages.houseUser.formNew.title.create': '新建房主',
  'pages.houseUser.formNew.section.accountInfo': '账户信息',
  'pages.houseUser.formNew.section.basicInfo': '基本信息',
  'pages.houseUser.formNew.section.contactInfo': '联系方式',
  'pages.houseUser.formNew.section.residenceInfo': '居住信息',
  'pages.houseUser.formNew.section.leaseInfo': '租赁信息',
  'pages.houseUser.formNew.section.remarks': '备注信息',
  'pages.houseUser.formNew.label.username': '用户名',
  'pages.houseUser.formNew.label.role': '角色',
  'pages.houseUser.formNew.label.status': '账户状态',
  'pages.houseUser.formNew.label.password': '密码',
  'pages.houseUser.formNew.label.confirmPassword': '确认密码',
  'pages.houseUser.formNew.label.name': '姓名',
  'pages.houseUser.formNew.label.gender': '性别',
  'pages.houseUser.formNew.label.birthDate': '出生日期',
  'pages.houseUser.formNew.label.idCard': '身份证号',
  'pages.houseUser.formNew.label.phone': '联系电话',
  'pages.houseUser.formNew.label.email': '邮箱',
  'pages.houseUser.formNew.label.address': '详细地址',
  'pages.houseUser.formNew.label.moveInDate': '入住日期',
  'pages.houseUser.formNew.label.moveOutDate': '搬出日期',
  'pages.houseUser.formNew.label.leaseStartDate': '租期开始日期',
  'pages.houseUser.formNew.label.leaseEndDate': '租期结束日期',
  'pages.houseUser.formNew.label.monthlyRent': '月租金',
  'pages.houseUser.formNew.label.depositAmount': '押金金额',
  'pages.houseUser.formNew.label.remarks': '备注',
  'pages.houseUser.formNew.placeholder.username': '请输入用户名',
  'pages.houseUser.formNew.placeholder.role': '请选择角色',
  'pages.houseUser.formNew.placeholder.status': '请选择状态',
  'pages.houseUser.formNew.placeholder.password': '请输入密码',
  'pages.houseUser.formNew.placeholder.confirmPassword': '请再次输入密码',
  'pages.houseUser.formNew.placeholder.name': '请输入姓名',
  'pages.houseUser.formNew.placeholder.gender': '请选择性别',
  'pages.houseUser.formNew.placeholder.birthDate': '请选择出生日期',
  'pages.houseUser.formNew.placeholder.idCard': '请输入身份证号',
  'pages.houseUser.formNew.placeholder.phone': '请输入联系电话',
  'pages.houseUser.formNew.placeholder.email': '请输入邮箱',
  'pages.houseUser.formNew.placeholder.address': '请输入详细地址',
  'pages.houseUser.formNew.placeholder.moveInDate': '请选择入住日期',
  'pages.houseUser.formNew.placeholder.moveOutDate': '请选择搬出日期',
  'pages.houseUser.formNew.placeholder.leaseStartDate': '请选择租期开始日期',
  'pages.houseUser.formNew.placeholder.leaseEndDate': '请选择租期结束日期',
  'pages.houseUser.formNew.placeholder.monthlyRent': '请输入月租金',
  'pages.houseUser.formNew.placeholder.depositAmount': '请输入押金金额',
  'pages.houseUser.formNew.placeholder.remarks': '请输入备注信息',
  'pages.houseUser.formNew.validation.username.required': '请输入用户名',
  'pages.houseUser.formNew.validation.username.minLength':
    '用户名长度不能少于4位',
  'pages.houseUser.formNew.validation.username.pattern':
    '用户名只能包含字母、数字和下划线',
  'pages.houseUser.formNew.validation.role.required': '请选择角色',
  'pages.houseUser.formNew.validation.status.required': '请选择状态',
  'pages.houseUser.formNew.validation.password.required': '请输入密码',
  'pages.houseUser.formNew.validation.password.minLength':
    '密码长度不能少于6位',
  'pages.houseUser.formNew.validation.confirmPassword.required':
    '请再次输入密码',
  'pages.houseUser.formNew.validation.confirmPassword.mismatch':
    '两次输入的密码不一致',
  'pages.houseUser.formNew.validation.name.required': '请输入姓名',
  'pages.houseUser.formNew.validation.name.minLength': '姓名长度不能少于2位',
  'pages.houseUser.formNew.validation.gender.required': '请选择性别',
  'pages.houseUser.formNew.validation.idCard.required': '请输入身份证号',
  'pages.houseUser.formNew.validation.phone.required': '请输入联系电话',
  'pages.houseUser.formNew.validation.email.pattern': '请输入正确的邮箱格式',
  'pages.houseUser.formNew.validation.remarks.maxLength':
    '备注长度不能超过500个字符',
  'pages.houseUser.formNew.button.update': '更新',
  'pages.houseUser.formNew.button.create': '创建',
  'pages.houseUser.formNew.button.cancel': '取消',
  'pages.houseUser.formNew.message.updateSuccess': '更新成功',
  'pages.houseUser.formNew.message.createSuccess': '创建成功',
  'pages.houseUser.formNew.message.updateFailed': '更新失败',
  'pages.houseUser.formNew.message.createFailed': '创建失败',
  'pages.houseUser.formNew.message.operationFailed': '操作失败',
  'pages.houseUser.table.title': '房主列表',
  'pages.houseUser.table.button.add': '新建房主',
  'pages.houseUser.table.column.userInfo': '用户信息',
  'pages.houseUser.table.column.contactInfo': '联系方式',
  'pages.houseUser.table.column.phone': '联系电话',
  'pages.houseUser.table.column.email': '邮箱',
  'pages.houseUser.table.column.emailPlaceholder': '请输入邮箱地址',
  'pages.houseUser.table.column.houseNumber': '房屋编号',
  'pages.houseUser.table.column.houseNumberPlaceholder': '请输入房屋编号',
  'pages.houseUser.table.column.building': '楼栋',
  'pages.houseUser.table.column.buildingPlaceholder': '请选择楼栋',
  'pages.houseUser.table.column.gender': '性别',
  'pages.houseUser.table.column.role': '角色',
  'pages.houseUser.table.column.status': '状态',
  'pages.houseUser.table.column.houseInfo': '房产信息',
  'pages.houseUser.table.column.moveInDate': '入住日期',
  'pages.houseUser.table.column.createTime': '创建时间',
  'pages.houseUser.table.column.operations': '操作',
  'pages.houseUser.table.button.view': '查看',
  'pages.houseUser.table.button.enable': '启用',
  'pages.houseUser.table.button.disable': '停用',
  'pages.houseUser.table.confirm.enable.title': '确定要启用该用户吗？',
  'pages.houseUser.table.confirm.enable.description':
    '启用后该用户将恢复正常使用',
  'pages.houseUser.table.confirm.disable.title': '确定要停用该用户吗？',
  'pages.houseUser.table.confirm.disable.description':
    '停用后该用户将无法正常使用',
  'pages.houseUser.table.confirm.okText': '确定',
  'pages.houseUser.table.confirm.cancelText': '取消',
  'pages.houseUser.table.message.enableSuccess': '启用成功',
  'pages.houseUser.table.message.disableSuccess': '停用成功',
  'pages.houseUser.table.message.enableFailed': '启用失败',
  'pages.houseUser.table.message.disableFailed': '停用失败',
  'pages.houseUser.tenant.title.edit': '编辑租客',
  'pages.houseUser.tenant.title.add': '添加租客',
  'pages.houseUser.tenant.label.house': '选择房产',
  'pages.houseUser.tenant.label.tenant': '选择租客',
  'pages.houseUser.tenant.label.leaseStartDate': '租赁开始日期',
  'pages.houseUser.tenant.label.leaseEndDate': '租赁结束日期',
  'pages.houseUser.tenant.label.monthlyRent': '月租金',
  'pages.houseUser.tenant.label.remarks': '备注',
  'pages.houseUser.tenant.placeholder.house': '请选择房产',
  'pages.houseUser.tenant.placeholder.houseLoading': '加载中...',
  'pages.houseUser.tenant.placeholder.tenant': '输入租客姓名、电话或邮箱',
  'pages.houseUser.tenant.placeholder.leaseStartDate': '请选择租赁开始日期',
  'pages.houseUser.tenant.placeholder.leaseEndDate': '请选择租赁结束日期',
  'pages.houseUser.tenant.placeholder.monthlyRent': '请输入月租金',
  'pages.houseUser.tenant.placeholder.remarks': '请输入备注信息',
  'pages.houseUser.tenant.validation.house.required': '请选择房产',
  'pages.houseUser.tenant.validation.tenant.required': '请选择租客',
  'pages.houseUser.tenant.message.loadHousesFailed': '加载房产列表失败',
  'pages.houseUser.tenant.message.searchFailed': '搜索用户失败',
  'pages.houseUser.tenant.message.selectHouseAndTenant': '请选择房产和租客',
  'pages.houseUser.tenant.message.updateSuccess': '更新成功',
  'pages.houseUser.tenant.message.createSuccess': '创建成功',
  'pages.houseUser.tenant.message.updateFailed': '更新失败',
  'pages.houseUser.tenant.message.createFailed': '创建失败',
  'pages.houseUser.tenant.text.rented': ' (已出租)',
  'pages.houseUser.tenant.text.invalidTenant': ' (不可选-非访客角色)',
  'pages.houseUser.vehicle.title.edit': '编辑车辆',
  'pages.houseUser.vehicle.title.add': '绑定车辆',
  'pages.houseUser.vehicle.section.parkingInfo': '车位信息',
  'pages.houseUser.vehicle.section.basicInfo': '基本信息',
  'pages.houseUser.vehicle.section.remarks': '备注信息',
  'pages.houseUser.vehicle.label.parking': '车位',
  'pages.houseUser.vehicle.label.plateNumber': '车牌号',
  'pages.houseUser.vehicle.label.vehicleType': '车辆类型',
  'pages.houseUser.vehicle.label.brand': '品牌',
  'pages.houseUser.vehicle.label.model': '车型',
  'pages.houseUser.vehicle.label.color': '车辆颜色',
  'pages.houseUser.vehicle.label.registrationDate': '注册日期',
  'pages.houseUser.vehicle.label.remarks': '备注',
  'pages.houseUser.vehicle.placeholder.plateNumber': '请输入车牌号',
  'pages.houseUser.vehicle.placeholder.vehicleType': '请选择车辆类型',
  'pages.houseUser.vehicle.placeholder.brand': '请输入品牌，如：奔驰、丰田',
  'pages.houseUser.vehicle.placeholder.model': '请输入车型，如：C级、卡罗拉',
  'pages.houseUser.vehicle.placeholder.color': '请输入车辆颜色',
  'pages.houseUser.vehicle.placeholder.registrationDate': '请选择注册日期',
  'pages.houseUser.vehicle.placeholder.remarks': '请输入备注信息',
  'pages.houseUser.vehicle.validation.plateNumber.required': '请输入车牌号',
  'pages.houseUser.vehicle.validation.plateNumber.maxLength':
    '车牌号长度不能超过20个字符',
  'pages.houseUser.vehicle.validation.vehicleType.required': '请选择车辆类型',
  'pages.houseUser.vehicle.validation.brand.maxLength':
    '品牌长度不能超过50个字符',
  'pages.houseUser.vehicle.validation.model.maxLength':
    '车型长度不能超过50个字符',
  'pages.houseUser.vehicle.validation.color.maxLength':
    '颜色长度不能超过20个字符',
  'pages.houseUser.vehicle.validation.remarks.maxLength':
    '备注长度不能超过500个字符',
  'pages.houseUser.vehicle.message.updateSuccess': '更新成功',
  'pages.houseUser.vehicle.message.createSuccess': '创建成功',
  'pages.houseUser.vehicle.message.updateFailed': '更新失败',
  'pages.houseUser.vehicle.message.createFailed': '创建失败',
  'pages.houseUser.table.headerTitle': '房主列表',
  'pages.houseUser.table.column.emailValidation.pattern':
    '请输入正确的邮箱格式',
  'pages.houseUser.table.pagination.showTotal':
    '第 {start}-{end} 条/总共 {total} 条',
  'pages.houseUser.table.role.owner': '业主',
  'pages.houseUser.table.role.tenant': '租户',
  'pages.houseUser.table.role.visitor': '访客',
  'pages.houseUser.table.status.normal': '正常',
  'pages.houseUser.table.status.disabled': '禁用',
  'pages.houseUser.table.status.other': '其他',
  'pages.houseUser.table.gender.male': '男',
  'pages.houseUser.table.gender.female': '女',
  'pages.houseUser.formNew.gender.male': '男',
  'pages.houseUser.formNew.gender.female': '女',
  'pages.houseUser.formNew.gender.other': '其他',
  'pages.houseUser.formNew.role.owner': '业主',
  'pages.houseUser.formNew.role.tenant': '租户',
  'pages.houseUser.formNew.role.visitor': '访客',
  'pages.houseUser.formNew.status.normal': '正常',
  'pages.houseUser.formNew.status.disabled': '禁用',
  'pages.houseUser.detail.editButton': '编辑',
  'pages.houseUser.detail.label.idCardNumber': '身份证号',
  'pages.houseUser.detail.status.normal': '正常',
  'pages.houseUser.detail.parkingStatus.available': '可用',
  'pages.houseUser.detail.parkingStatus.sold': '已售',
  'pages.houseUser.detail.parkingStatus.rented': '已租',
  'pages.houseUser.detail.parkingStatus.reserved': '预留',
  'pages.houseUser.detail.parkingStatus.disabled': '禁用',
  'pages.houseUser.detail.text.locationInfo': '位置信息',
  'pages.houseUser.detail.text.structureCode': '结构编码',
  'pages.houseUser.detail.text.parkingType': '车位类型',
  'pages.houseUser.detail.text.startTime': '开始时间',
  'pages.houseUser.detail.text.ownerInfo': '业主信息',
  'pages.houseUser.detail.text.tenantName': '租客姓名',
  'pages.houseUser.detail.text.houseInfo': '房屋信息',
  'pages.houseUser.detail.text.monthlyRent': '月租金',
  'pages.houseUser.detail.text.leaseStartDate': '租赁开始',
  'pages.houseUser.detail.text.leaseEndDate': '租赁结束',
  'pages.houseUser.detail.text.buildingName': '楼栋',
  'pages.houseUser.detail.text.floor': '楼层',
  'pages.houseUser.detail.text.houseNumber': '房屋号',
  'pages.houseUser.detail.text.area': '面积',
  'pages.houseUser.detail.text.amount': '金额',
  'pages.houseUser.detail.text.remarks': '备注',
  'pages.houseUser.detail.text.serviceCount': '服务数',
  'pages.houseUser.detail.text.bindVehicle': '已绑定车辆',
  'pages.houseUser.detail.text.noVehicle': '暂无绑定车辆',
  'pages.houseUser.detail.text.brandModel': '品牌/型号',
  'pages.houseUser.detail.text.vehicleColor': '车辆颜色',
  'pages.houseUser.detail.text.vehicleType': '车辆类型',
  'pages.houseUser.detail.text.registrationDate': '注册日期',
  'pages.houseUser.detail.text.bindVehicleButton': '+ 绑定车辆',
  'pages.houseUser.detail.text.editVehicleButton': '编辑',
  'pages.houseUser.detail.text.daysLeft': '即将到期({days}天)',
  'pages.houseUser.detail.text.addTenant': '+ 添加租客',
  'pages.houseUser.detail.text.parkingList': '停车位列表',
  'pages.houseUser.detail.text.boundVehicles': '已绑定车辆',
  'pages.houseUser.detail.text.noVehicles': '暂无车辆',
  'pages.houseUser.detail.text.openedServices': '已开通的服务',
  'pages.houseUser.detail.text.noOpenedServices': '暂无已开通的服务',
  'pages.houseUser.detail.text.emergencyContactsList': '紧急联系人列表',
  'pages.houseUser.detail.text.addContact': '添加联系人',
  'pages.houseUser.detail.text.noEmergencyContacts': '暂无紧急联系人',
  'pages.houseUser.detail.text.mobileNumber': '手机号码',
  'pages.houseUser.detail.text.emailAddress': '电子邮箱',
  'pages.houseUser.detail.text.checkInDate': '入住日期',
  'pages.houseUser.detail.text.houseInformation': '房屋信息',
  'pages.houseUser.detail.text.building': '楼栋：',
  'pages.houseUser.detail.text.floorLevel': '楼层：',
  'pages.houseUser.detail.text.houseNumberLabel': '房屋号：',
  'pages.houseUser.detail.text.servicesCount': '服务数：',
  'pages.houseUser.detail.text.serviceName': '服务名称',
  'pages.houseUser.detail.text.enabled': '启用',
  'pages.houseUser.detail.text.paused': '暂停',
  'pages.houseUser.detail.text.disabled': '停用',
  'pages.houseUser.detail.text.rentedHouse': '租住房屋',
  'pages.houseUser.detail.text.rent': '月租金',
  'pages.houseUser.detail.text.leaseStart': '租赁开始',
  'pages.houseUser.detail.text.leaseEnd': '租赁结束',
  'pages.houseUser.detail.text.renting': '租赁中',
  'pages.houseUser.detail.text.parkingNumber': '车位编号',
  'pages.houseUser.detail.text.parkingStatus': '车位状态',
  'pages.houseUser.detail.text.vehicleInfo': '车辆信息',
  'pages.houseUser.detail.text.serviceInfo': '服务信息',
  'pages.houseUser.detail.card.identityVerification': '身份核验',
  'pages.houseUser.detail.card.accountStatus': '账户状态',
  'pages.houseUser.detail.button.changePassword': '修改密码',
  'pages.houseUser.detail.button.permissions': '权限设置',
  'pages.houseUser.detail.label.accountStatus': 'ACCOUNT STATUS',
  'pages.houseUser.detail.label.idNumber': 'ID Number',
  'pages.houseUser.detail.files.search.placeholder': '搜索文件名',
  'pages.houseUser.detail.files.button.upload': '上传新文件',
  'pages.houseUser.detail.files.empty': '暂无文件',
  'pages.houseUser.detail.files.message.loadListFailed': '加载文件列表失败',
  'pages.houseUser.detail.files.message.selectFile': '请选择要上传的文件',
  'pages.houseUser.detail.files.message.uploadFailed': '文件上传失败',
  'pages.houseUser.detail.files.message.uploadedButNoPath':
    '文件上传成功，但无法获取文件路径',
  'pages.houseUser.detail.files.message.uploadSuccess': '文件上传成功',
  'pages.houseUser.detail.files.message.saveRecordFailed': '保存文件记录失败',
  'pages.houseUser.detail.files.message.loadDetailFailed': '获取文件详情失败',
  'pages.houseUser.detail.files.confirm.delete.title': '确认删除',
  'pages.houseUser.detail.files.confirm.delete.content':
    '确定要删除这个文件吗？此操作不可恢复。',
  'pages.houseUser.detail.files.confirm.delete.okText': '删除',
  'pages.houseUser.detail.files.confirm.delete.cancelText': '取消',
  'pages.houseUser.detail.files.message.deleteSuccess': '删除成功',
  'pages.houseUser.detail.files.message.deleteFailed': '删除失败',
};
